import Images from "../../assets/Images";

export const PROJECT_TITLE = "Corona STOP";
export const SERVICE = "36";

export const TARGET_NAME = {
  SOCMEDICA: 'SOCMEDICA',
  RZD: 'RZD',
  RZD_EMPL: 'RZD_EMPL',
  DOC_HOSPITAL: 'DOC_HOSPITAL'
};

export const PRODUCT = TARGET_NAME.SOCMEDICA; // RZD, SOCMEDICA, RZD_EMPL, DOC_HOSPITAL
export const PRODUCTION = true;
export const API_SERVER = PRODUCTION ? "https://prod.socmedica.com/version/api/ET" : "https://dev.socmedica.com/2/api/ET";

import styles_main from '../styles/main';
import styles_rzd from '../styles/rzd';


const MAIN_SETTINGS = {
  MIN_WIDTH: 900,
  AUTH_SERVICE_KEY: "7e649ecb733d2af1",
  COVER_TIMEOUT: 2000,
  AUTH_ENABLED: false,
  CATCH_EXIT: true,
  PRODUCT: PRODUCT
};

const SETTINGS = {
  'RZD': {
    ...MAIN_SETTINGS,
    COLOR: '#828182',
    REQUEST_PATH: `${API_SERVER}/CoronaStopRZD`,
    FIXED_HEADER: true,
    CATCH_EXIT_URL: `${API_SERVER}/CoronaStopRZD`,
    styles: styles_rzd
  },
  'RZD_EMPL': {
    ...MAIN_SETTINGS,
    COLOR: '#828182',
    REQUEST_PATH: `${API_SERVER}/CoronaStopRZDEmployees`,
    FIXED_HEADER: true,
    CATCH_EXIT_URL: `${API_SERVER}/CoronaStopRZDEmployees`,
    styles: styles_rzd
  },
  'SOCMEDICA': {
    ...MAIN_SETTINGS,
    COLOR: '#D30000',
    REQUEST_PATH: `${API_SERVER}/CoronaStop`,
    // в данный момент FIXED_HEADER не отражает суть, если этот параметр true, 
    // то всё приложение оборачивается в AppScrollView и срабатывает автопрокрутка. 
    // Когда будут реальноые фиксированные хеадеры, нужно будет доработать AppScrollView
    FIXED_HEADER: true,
    CATCH_EXIT_URL: '',
    styles: styles_main
  },
  'DOC_HOSPITAL': {
    ...MAIN_SETTINGS,
    COLOR: '#D30000',
    REQUEST_PATH: `${API_SERVER}/CoronaStopDocHospital`,
    // на 05,05,2020 DOC_HOSPITAL визуально идентичен SOCMEDICA
    // в данный момент FIXED_HEADER не отражает суть, если этот параметр true,
    // то всё приложение оборачивается в AppScrollView и срабатывает автопрокрутка.
    // Когда будут реальноые фиксированные хеадеры, нужно будет доработать AppScrollView
    FIXED_HEADER: true,
    CATCH_EXIT_URL: '',
    styles: styles_main
  }
};


export const C = SETTINGS[PRODUCT];
export const styles = SETTINGS[PRODUCT].styles;

// export const SERVICE_KEY = "be1fe504f12126fd";

export const IMG =
    (PRODUCT === TARGET_NAME.SOCMEDICA || PRODUCT === TARGET_NAME.DOC_HOSPITAL)
        ? {
          Info: Images.INFO_MAIN,
          Warning: Images.WARNING_MAIN,
          Error: Images.ERROR_MAIN
        }
        : {
          Info: Images.INFO_RZD,
          Warning: Images.WARNING_RZD,
          Error: Images.ERROR_RZD
        }

// For tests
export const json1 = {
  "url": "http://socmedica.com/?service=coronastop&step=2",
  "blocks": [
    {
      "required": true,
      "type": "TEXT",
      "elements": [
        {
          "label": "Сколько Вам лет?"
        },
        {
          "label": "90%",
          "style": {
            "fontSize": "30",
            "color": "orange",
            "fontWeight": "bold"
          }
        }
      ]
    },
    {
      "type": "SELECT",
      "name": "age",
      "elements": [
        {
          "label": "10",
          "value": "10"
        },
        {
          "label": "30",
          "value": "30"
        },
        {
          "label": "80",
          "value": "80"
        }
      ]
    },
    {
      "type": "BUTTON",
      "name": "answer1",
      "elements": [
        {
          "label": "Дальше",
          "value": "1",
          "action": {
            "type": "getBlock",
            "url": "1"
          }
        }
      ]
    }
  ]
};


export const json2 = {
  "url": "http://socmedica.com/?service=coronastop&step=2",
  "blocks": [
    {
      "required": null,
      "type": "TEXT",
      "name": null,
      "elements": [
        {
          "label": "Была ли у вас температура за последние 10-14 дней?",
          "value": null
        }
      ]
    },
    {
      "required": true,
      "type": "BUTTON",
      "name": "answer1",
      "elements": [
        {
          "label": "Нет",
          "value": "0",
          "action": {
            "type": "getBlock",
            "url": "2"
          }
        },
        {
          "label": "Да",
          "value": "1",
          "action": {
            "type": "getBlock",
            "url": "http://socmedica.com/?service=coronastop&step=88"
          }
        }
      ]
    }
  ]
};

export const json3 = {
  "url": "http://socmedica.com/?service=coronastop&step=2",
  "blocks": [
    {
      "required": null,
      "type": "TEXT",
      "name": null,
      "elements": [
        {
          "label": "Была ли у вас температура за последние 10-14 дней?",
          "value": null
        }
      ]
    },
    {
      "required": true,
      "type": "BUTTON",
      "name": "answer1",
      "elements": [
        {
          "label": "Нет",
          "value": "0",
          "action": {
            "type": "getBlock",
            "url": "http://socmedica.com/?service=coronastop&step=88"
          }
        },
        {
          "label": "Да",
          "value": "1",
          "action": {
            "type": "getBlock",
            "url": "http://socmedica.com/?service=coronastop&step=88"
          }
        }
      ]
    },
    {
      "required": null,
      "type": "SELECT",
      "name": "age",
      "elements": [
        {
          "label": "10",
          "value": "10"
        },
        {
          "label": "30",
          "value": "30"
        },
        {
          "label": "80",
          "value": "80"
        }
      ]
    },
    {
      "required": null,
      "type": "CHECKBOX",
      "name": "food",
      "elements": [
        {
          "label": "Рыба",
          "value": "1"
        },
        {
          "label": "Мясо",
          "value": "2"
        },
        {
          "label": "Фрукты",
          "value": "3"
        }
      ]
    },
    {
      "required": null,
      "type": "RADIOBUTTON",
      "name": "food",
      "elements": [
        {
          "label": "Рыба",
          "value": "1"
        },
        {
          "label": "Мясо",
          "value": "2"
        },
        {
          "label": "Фрукты",
          "value": "3"
        }
      ]
    },
    {
      "required": null,
      "type": "TEXT",
      "name": null,
      "color": "error",
      "elements": [
        {
          "label": "Вероятность осложнений:",
          "value": null
        },
        {
          "label": "70%",
          "value": null,
          "style": {
            "fontSize": "30px",
            "fontWeight": "bold"
          }
        }
      ]
    },
    {
      "required": null,
      "type": "LIST",
      "name": "food",
      "elements": [
        {
          "label": "Рекомендации",
          "action": {
            "type": "openUrl",
            "url": "http://site.ru"
          }
        },
        {
          "label": "Ответить на другие вопросы",
          "action": {
            "type": "getBlock",
            "url": "http://socmedica.com/?service=coronastop&step=88"
          }
        }
      ]
    }
  ]
};


export const json4 = [
  {
    "id": "1",
    "name": "Россия",
  },
  {
    "id": "2",
    "name": "Россия2",
  },
  {
    "id": "3",
    "name": "Россия3",
  },
  {
    "id": "4",
    "name": "Россия4",
  },
  {
    "id": "5",
    "name": "Россия",
  },
  {
    "id": "6",
    "name": "Россия",
  },
  {
    "id": "7",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  },
  {
    "id": "123",
    "name": "Россия",
  }
];